import { makeStyles } from '@rbx/ui';

const useMetricValueStyles = makeStyles()(() => ({
  comparisonChipMargin: {
    margin: '0 8px',
  },

  iconPadding: {
    marginRight: '4px',
  },
}));

export default useMetricValueStyles;
